import {useCallback, useContext} from "react";

import type {AnalyticsEvent} from "@khanacademy/event-schemas";

import {LearningTimeInfoApiContext} from "./internal/learning-time-info-api-context.ts";
import {publishAnalyticsEvent} from "./internal/publish-analytics-event.ts";
import type {ConversionName, PublishAnalyticsEventT} from "./types.ts";

/**
 * @returns {PublishAnalyticsEventT} A stable function that can be used to
 * publish an analytics event.
 */
export const usePublishAnalyticsEvent = (): PublishAnalyticsEventT => {
    const learningTimeInfoApi = useContext(LearningTimeInfoApiContext);

    return useCallback(
        (event: AnalyticsEvent, legacyConversionName?: ConversionName) =>
            publishAnalyticsEvent(
                event,
                learningTimeInfoApi.combinedLti,
                legacyConversionName,
            ),
        [learningTimeInfoApi],
    );
};
